import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import moment from "moment";
import Constants from "../data/Constants";
import { Link } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function OrderDetailsDialog(props) {
  const { open, order, onClose } = props;

  return order ? (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} className="font-extrabold text-lg">
            Order Details
          </Box>
          <Box>
            <IconButton onClick={onClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="grid" style={{ minWidth: "450px" }}>
          <h1 className=" my-1 text-sm">
            <b>Order Number:</b> <span>{order.orderNumber}</span>
          </h1>
          <h1 className=" my-1 text-sm">
            <b>Total Amount:</b>{" "}
            <span>{Constants.CURRENCY_SYMBOL + order.totalAmount}</span>
          </h1>
          <h1 className=" my-1 text-sm">
            <b>Discount Amount:</b>{" "}
            <span>{Constants.CURRENCY_SYMBOL + order.discountAmount}</span>
          </h1>
          <h1 className=" my-1 text-sm">
            <b>Payable Amount:</b>{" "}
            <span>{Constants.CURRENCY_SYMBOL + order.payableAmount}</span>
          </h1>
          <h1 className=" my-1 text-sm">
            <b>Status:</b> <span>{order.status}</span>
          </h1>

          <h1 className=" my-1 text-sm">
            <b>User:</b>{" "}
            <span>
              <Link
                to={"/dashboard/mentees/" + order.createdBy._id}
                className="hover:underline"
              >
                {order.createdBy.firstname
                  ? order.createdBy.firstname + " " + order.createdBy.lastname
                  : "Unknown"}
              </Link>
            </span>
          </h1>

          <h1 className=" my-1 text-sm">
            <b>Coupon Applied:</b>{" "}
            <span>{order.coupon ? order.coupon.code : "No"}</span>
          </h1>

          <h1 className="font-bold my-2 text-sm">Courses:</h1>

          <div className="my-2">
            {order.courses.length == 0 && (
              <div className="text-xsm font-gray-400">No Items</div>
            )}

            {order.courses.map((courseObj) => {
              return (
                <Chip
                  label={
                    courseObj.course.name +
                    (courseObj.courseClass
                      ? " • BATCH " + courseObj.courseClass.batchNumber
                      : "")
                  }
                  className="m-1"
                />
              );
            })}
          </div>

          <h1 className="font-bold my-2 text-sm">Counselling:</h1>

          <div className="my-2">
            {order.counselling.length == 0 && (
              <div className="text-xsm font-gray-400">No Items</div>
            )}
            {order.counselling.map((courseObj) => {
              return (
                <Chip
                  label={
                    courseObj.mentor.firstname + " " + courseObj.mentor.lastname
                  }
                />
              );
            })}
          </div>

          <h1 className="font-bold my-2 text-sm">Billing Details:</h1>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Fullname
                </TableCell>
                <TableCell className="">
                  {order.billing.fullname ?? "Not Set"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  mobile
                </TableCell>
                <TableCell className="">
                  {order.billing.mobile ?? "Not Set"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Email
                </TableCell>
                <TableCell className="">
                  {order.billing.email ?? "Not Set"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Address
                </TableCell>
                <TableCell className="">
                  {order.billing.address ?? "Not Set"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  City
                </TableCell>
                <TableCell className="">
                  {order.billing.city ?? "Not Set"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  State
                </TableCell>
                <TableCell className="">
                  {order.billing.state ?? "Not Set"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Pincode
                </TableCell>
                <TableCell className="">
                  {order.billing.zip ?? "Not Set"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Updated At
                </TableCell>
                <TableCell className="">
                  {moment(order.billing.updatedAt).format(
                    Constants.DATE_TIME_FORMAT
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    ""
  );
}

export default OrderDetailsDialog;
